/**
 * Service: posConfigNavigation
 */
angular.module('acme.common.service.posConfigNavigation', [])
.service('PosConfigNavigationService', [function() {

    return {

      model: [],

      init: function() {
        return true;
      },

      setModel: function(model) {
        if (model && model instanceof Array) {

          angular.forEach(model, function (item, key) {
            if (!item.text.length) {
              item.text = item.name;
            }
          });

          this.model = model;
        } else {
          this.reset();
        }
      },

      getModel: function() {
        return this.model;
      },

      reset: function() {
        this.model = [
          {
            "order": 0,
            "type": "retail",
            "name": "Retail",
            "text": "Retail",
            "color": {
              "r": 0,
              "g": 176,
              "b": 238,
              "a": 1
            },
            "display": true
          },
          {
            "order": 1,
            "type": "members",
            "name": "Indv. Members",
            "text": "Indv. Members",
            "color": {
              "r": 0,
              "g": 176,
              "b": 238,
              "a": 1
            },
            "display": true
          },
          {
            "order": 2,
            "type": "groups",
            "name": "Organizations",
            "text": "Organizations",
            "color": {
              "r": 0,
              "g": 176,
              "b": 238,
              "a": 1
            },
            "display": true
          },
          {
            "order": 3,
            "type": "corporate",
            "name": "Org. Members",
            "text": "Org. Members",
            "color": {
              "r": 0,
              "g": 176,
              "b": 238,
              "a": 1
            },
            "display": true
          },
          {
            "order": 4,
            "type": "customer",
            "name": "Customers",
            "text": "Customers",
            "color": {
              "r": 0,
              "g": 176,
              "b": 238,
              "a": 1
            },
            "display": true
          }
        ];
      }

    };

}]);
